const States ={
  AL: "Alabama",
  AK: "Alaska",
  AZ: "Arizona",
  AR: "Arkansas",
  CA: "California",
  CO: "Colorado",
  CT: "Connecticut",
  DE: "Delaware",
  DC: "District Of Columbia",
  FL: "Florida",
  GA: "Georgia",
  HI: "Hawaii",
  ID: "Idaho",
  IL: "Illinois",
  IN: "Indiana",
  IA: "Iowa",
  KS: "Kansas",
  KY: "Kentucky",
  LA: "Louisiana",
  ME: "Maine",
  MD: "Maryland",
  MA: "Massachusetts",
  MI: "Michigan",
  MN: "Minnesota",
  MS: "Mississippi",
  MO: "Missouri",
  MT: "Montana",
  NE: "Nebraska",
  NV: "Nevada",
  NH: "New Hampshire",
  NJ: "New Jersey",
  NM: "New Mexico",
  NY: "New York",
  NC: "North Carolina",
  ND: "North Dakota",
  OH: "Ohio",
  OK: "Oklahoma",
  OR: "Oregon",
  PA: "Pennsylvania",
  PR: "Puerto Rico",
  RI: "Rhode Island",
  SC: "South Carolina",
  SD: "South Dakota",
  TN: "Tennessee",
  TX: "Texas",
  UT: "Utah",
  VT: "Vermont",
  VA: "Virginia",
  WA: "Washington",
  WV: "West Virginia",
  WI: "Wisconsin",
  WY: "Wyoming",
};

const Credentials = {
    APRN: { label: "APRN", requiresNPI: false },
    CNM: { label: "CNM", requiresNPI: true },
    CRNA: { label: "CRNA", requiresNPI: false },
    DDS: { label: "DDS", requiresNPI: false },
    DMD: { label: "DMD", requiresNPI: false },
    DNP: { label: "DNP", requiresNPI: false },
    DO: { label: "DO", requiresNPI: false },
    DPM: { label: "DPM", requiresNPI: false },
    LPN: { label: "LPN", requiresNPI: false },
    MD: { label: "MD", requiresNPI: false },
    NonHCP: { label: "Non-HCP", requiresNPI: true },
    NP: { label: "NP", requiresNPI: false },
    OLHCP: { label: "Other Licensed HCP", requiresNPI: true },
    RN: { label: "RN", requiresNPI: true },
    RNBC: { label: "RN-BC", requiresNPI: true },
    RNC: { label: "RN-C", requiresNPI: true },
    RPH: { label: "RPH", requiresNPI: true }
};

const Specialties = {
  Anesthesiology: "Anesthesiology",
  BariatricSurgery: "Bariatric Surgery",
  CardiacSurgery: "Cardiac Surgery",
  ColorectalSurgery: "Colorectal Surgery",
  GeneralSurgery: "General Surgery",
  ObstetricsSurgery: "Obstetrics/Gynecologic Surgery/Urogynecologist",
  Nursing: "Nursing",
  OralSurgery: "Oral Surgery",
  OrthopedicSurgery: "Orthopedic Surgery",
  PainManagement: "Pain Management",
  PediatricSurgery: "Pediatric Surgery",
  PlasticSurgery: "Plastic Surgery",
  SpineNeurosurgery: "Spine/Neurosurgery",
  UrologyNephrology: "Urology/Nephrology",
  Other: "Other",
};

export { States, Credentials, Specialties};